module.exports = __webpack_public_path__ + "img/footer_amil_logo_01.f7832f4c.webp";